<template>
    <v-dialog
        v-model="abrir"
        max-width="800px" 
        scrollable
        persistent>
        <v-card>
        <v-card-title>
            <span class="headline">{{ titulo }} </span>
        </v-card-title>

        <v-card-text>
            <v-tabs
                color = "blue"
                dark
                fixed-tabs
                slider-color="yellow"
                icons-and-text >
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab>
                    Registrar beneficiarios al grupo
                    <v-icon>mdi-account-plus</v-icon>
                </v-tab>
                <v-tab>
                    Remover beneficiarios del grupo
                    <v-icon>mdi-account-remove</v-icon>
                </v-tab>
                <v-tab-item>
                    <v-container>
                        <v-layout rows wrap>
                            <v-flex>
                                <v-text-field
                                    label = "Buscar"
                                    color = "info"
                                    v-model = "searchE"
                                    append-icon="mdi-magnify"
                                    placeholder="Buscar beneficiario"
                                    hide-details
                                />
                            </v-flex>
                            <v-flex pl-3>
                                <v-btn dark color="blue darken-1" @click="inscribir()" :disabled = "activarBoton">
                                    <v-icon left>mdi-account-check</v-icon>
                                    <span>Enrolar seleccion</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-data-table
                        :headers = "headers"
                        :items = "datosEnrolar"
                        item-key = "_id"
                        v-model = "seleccionEnrolar"
                        :search = "searchE"
                        select-all
                        no-results-text = "No hay registros para mostrar"
                        class="elevation-1"
                    >    
                        <template
                            slot="items"
                            slot-scope="props"
                        >
                            <td>
                                <v-checkbox
                                    v-model = "props.seleccionEnrolar"
                                    primary
                                    hide-details
                                ></v-checkbox>
                            </td>
                            <td class="text-xs-left">
                                {{ props.item._id }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.nombre }}
                            </td>   
                            <td class="text-xs-left">
                                {{ props.item.aPaterno }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.aMaterno }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.edad }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.telefono }}
                            </td>
                        </template>
                    </v-data-table>  
                </v-tab-item>
                <v-tab-item>
                    <v-container>
                        <v-layout rows wrap>
                            <v-flex>
                                <v-text-field
                                    label = "Buscar"
                                    color = "info"
                                    v-model = "searchR"
                                    append-icon="mdi-magnify"
                                    placeholder="Buscar Inscritos"
                                    hide-details
                                />
                            </v-flex>
                            <v-flex>
                                <v-btn dark color="blue darken-1" @click="remover()">
                                    <v-icon left>mdi-account-minus</v-icon>
                                    <span>Remover del grupo</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-data-table
                        :headers = "headers"
                        :items = "datosInscritos"
                        item-key = "_id"
                        :search = "searchR"
                        v-model = "seleccionInscritos"
                        no-results-text = "No hay registros para mostrar"
                        class="elevation-1"
                    >    
                        <template
                            slot="items"
                            slot-scope = "props"
                        >
                            <td>
                                <v-checkbox
                                    v-model = "props.seleccionInscritos"
                                    primary
                                    hide-details
                                ></v-checkbox>
                            </td>
                            <td class="text-xs-left">
                                {{ props.item._id }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.nombre }}
                            </td>   
                            <td class="text-xs-left">
                                {{ props.item.aPaterno }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.aMaterno }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.edad }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.telefono }}
                            </td>
                        </template>
                    </v-data-table>  
                </v-tab-item>
            </v-tabs>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
            color="blue darken-1"
            text
            @click = "cerrar">Cerrar</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        abrir: Boolean,
        titulo: String
    },
    data() {
        return {
            pagination: {
                sortBy: 'nombre'
            },
            seleccionEnrolar: [],
            datosEnrolar: [],
            datosInscritos: [],
            seleccionInscritos: [],
            searchE: '',
            searchR: '',
            headers: [
                {
                    text: '_id',
                    value: 'ID',
                },
                {
                    text: 'Nombre(s)',
                    value: 'nombre',
                },
                {
                    text: 'Paterno',
                    value: 'aPaterno',
                },
                {
                    text: 'Materno',
                    value: 'aMaterno',
                },
                {
                    text: 'Edad',
                    value: 'edad',
                }
            ],
        }
    },
    computed: {
        activarBoton(){
            return false
        }
    },
    created () {
      this.initialize()
    },

    methods: {  
        async initialize () {
            try{
                this.datosEnrolar = await ServiceHandler.getElements("beneficiarios/bentemp");
            }catch(e){
                this.error = e.message;
            }
        },
        cerrar() {
            this.$emit('cerrarVentana');
        },
        toggleAll () {
            console.log(this.seleccionEnrolar.length);
            if (this.seleccionEnrolar.length) this.seleccionEnrolar = [] 
            else this.seleccionEnrolar = this.datosEnrolar.slice();

            /*if (this.seleccionInscritos.length) this.seleccionInscritos = [] 
            else this.seleccionInscritos = this.datosInscritos.slice();*/

        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        inscribir(){
            console.log(this.seleccionEnrolar.length);
        },
        remover(){

        }
    },
}
</script>